import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { ButtonMain, CheckPassword, InputMain } from "components";
import { FindError, FindLoad, FindSuccess, PasswordValidator } from "utils";
import {
  authActions,
  httpRequestsOnErrorsActions,
  httpRequestsOnSuccessActions,
} from "store";
import { checkPassword } from "../../../auth/constants";
import { Svg } from "assets";

const ACTION_TYPE = "CHANGE_PASSWORD_REQUEST";

export const ChangePassword = () => {
  const [showInputs, setShowInputs] = useState(false);
  const { handleSubmit, control, setError, clearErrors, reset, watch } =
    useForm({
      defaultValues: {
        password: "",
        newPassword: "",
        confirmation: "",
      },
    });
  const dispatch = useDispatch();

  const successType = FindSuccess(ACTION_TYPE);
  const loader = FindLoad(ACTION_TYPE);
  const errorPasswords = FindError(ACTION_TYPE);

  useEffect(() => {
    if (successType?.length) {
      setShowInputs(false);
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
    }
  }, [successType]);

  useEffect(() => {
    if (
      errorPasswords?.error ===
      "The new password does not match with the confirmation"
    ) {
      setError("newPassword", {
        type: "required",
        message: "The new password does not match with the confirmation",
      });
    }
    if (errorPasswords?.error === "User password does not match") {
      setError("password", {
        type: "required",
        message: "User password does not match",
      });
    }
  }, [errorPasswords]);

  const onSubmitPassword = (data) => {
    if (data?.newPassword === data?.confirmation) {
      dispatch(authActions.changePassword(data));
    } else {
      setError("confirmation", {
        type: "required",
        message: "Passwords do not match.",
      });
    }
  };

  const handleChancel = () => {
    setShowInputs(false);
    clearErrors();
    reset({
      password: "",
      newPassword: "",
      confirmation: "",
    });
    dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
  };

  return (
    <div className="change-pass-wrapper">
      <div className="upload-avatar-svg_title-edit-btn">
        <div className="upload-avatar-svg_title">
          <Svg.LockPassSvg />

          <p className="upload-avatar-title">Change Password</p>
        </div>

        {!showInputs && (
          <div
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowInputs(true);
            }}
          >
            <Svg.EditInfoSvg style={{ cursor: "pointer" }} />
          </div>
        )}
      </div>

      {showInputs && (
        <div>
          <div style={{ padding: "8px 16px" }}>
            <InputMain
              name="password"
              control={control}
              type="password"
              placeholder="Current Password*"
              rules={{
                required: "This Field is required",
                pattern: {
                  value: PasswordValidator,
                  message: "Not valid Password",
                },
              }}
            />

            <InputMain
              name="newPassword"
              control={control}
              type="password"
              placeholder="New Password*"
              rules={{
                required: "This Field is required",
                pattern: {
                  value: PasswordValidator,
                  message: "Not valid Password",
                },
              }}
            />

            <InputMain
              name="confirmation"
              control={control}
              type="password"
              placeholder="Retype New Password*"
              rules={{
                required: "This Field is required",
                pattern: {
                  value: PasswordValidator,
                  message: "Not valid Password",
                },
              }}
            />
            <CheckPassword
              fields={checkPassword}
              text={watch("newPassword")}
              isActive={watch("newPassword")}
            />
          </div>

          <div className="flex" style={{ gap: 10, padding: "16px" }}>
            <ButtonMain
              type={"button"}
              onClick={handleChancel}
              cancel
              text="Cancel"
              small
            />

            <ButtonMain
              text="Change"
              load={!!loader.length}
              onClick={handleSubmit(onSubmitPassword)}
              small
            />
          </div>
        </div>
      )}
    </div>
  );
};
